import React, {useState, use, createContext} from "react";
import PropTypes from "prop-types";
import {initializeTheme, toggleTheme} from "../resources/theme";

export const ThemeWrapperContext = createContext(null);

export const ThemeWrapperProvider = ({children}) => {
  const [activeTheme, setActiveTheme] = useState(() => initializeTheme());

  const toggleActiveTheme = (themeName) => toggleTheme({activeTheme, setActiveTheme}, themeName);

  return (
    <ThemeWrapperContext value={{activeTheme, setActiveTheme, toggleActiveTheme}}>
      {children}
    </ThemeWrapperContext>
  );
};

ThemeWrapperProvider.propTypes = {
  children: PropTypes.any,
};

export const useTheme = () => {
  return use(ThemeWrapperContext);
};
